import type { User } from '@supabase/supabase-js'

/**
 * Email+password signups park their registration details (token status, project
 * name, ticker, telegram) in Supabase user metadata until the confirmation email
 * is clicked. Builds the `/onboarding/finalize-registration` request body from
 * that metadata, or returns null when the user has no pending registration.
 */
export function pendingRegistrationBody(user: User | null | undefined) {
  const meta = (user?.user_metadata ?? {}) as Record<string, any>
  const reg = meta.registration as Record<string, any> | undefined
  if (!reg) {
    return null
  }
  return {
    firstName: meta.first_name ?? '',
    lastName: meta.last_name ?? '',
    telegram: reg.telegram ?? undefined,
    tokenStatus: reg.tokenStatus ?? 'no-token',
    coingeckoId: reg.coingeckoId ?? null,
    projectName: reg.projectName ?? '',
    ticker: reg.ticker ?? '',
  }
}
